export default __webpack_public_path__ + "static/media/information--dead-end-left--g1.81116d41.png";